import React from 'react';
import { Helmet } from 'react-helmet';
import { Dashboard } from 'layouts/Dashboard';
import { FlowArea } from 'components';

const FlowAreaShare = () => {
  return (
    <>
      <Helmet>
        <title>ezFlow Dialog Prewiew</title>
      </Helmet>

      <Dashboard>
        <FlowArea flowPreview />
      </Dashboard>
    </>
  );
};

export default FlowAreaShare;
